// Supermove
import {gql} from '@supermove/graphql';
import {Form} from '@supermove/hooks';
import {ProjectModel, UserModel} from '@supermove/models';
import {withFragment} from '@supermove/utils';

// Shared
import ProjectForm from '@shared/modules/Project/forms/ProjectForm';

// Note(Hammad) ProjectForm does not have a toForm type, so using any for at the moment.
// We also cannot create a mutation type because ProjectForm is missing its toMutation type.
export type DuplicateProjectFormFieldsType = {
  projectForm: any;
  shouldCopySurvey: boolean;
  shouldCopyJobs: boolean;
  shouldCopyAssignedMovers: boolean;
  shouldCopyAssignedTrucks: boolean;
  shouldCopyBilling: boolean;
};

export type DuplicateProjectFormType = Form<{
  duplicateProjectForm: DuplicateProjectFormFieldsType;
}>;

const _new = withFragment(
  (project: ProjectModel, viewer: UserModel): DuplicateProjectFormFieldsType => {
    const copiedProjectForm = ProjectForm.copy(project);

    // Override creatorId with viewer's id to ensure duplicated project has correct creator
    copiedProjectForm.creatorId = viewer.id;

    return {
      projectForm: ProjectForm.toForm(copiedProjectForm),
      shouldCopySurvey: false,
      shouldCopyJobs: false,
      shouldCopyAssignedMovers: false,
      shouldCopyAssignedTrucks: false,
      shouldCopyBilling: false,
    };
  },
  gql`
    ${ProjectForm.copy.fragment}
    fragment DuplicateProjectForm_new on Project {
      id
      ...ProjectForm_copy
    }
  `,
);

const toMutation = ({
  projectForm,
  shouldCopySurvey,
  shouldCopyJobs,
  shouldCopyAssignedMovers,
  shouldCopyAssignedTrucks,
  shouldCopyBilling,
}: DuplicateProjectFormFieldsType): DuplicateProjectFormFieldsType => {
  return {
    projectForm: ProjectForm.toMutation(projectForm),
    shouldCopySurvey,
    shouldCopyJobs,
    shouldCopyAssignedMovers,
    shouldCopyAssignedTrucks,
    shouldCopyBilling,
  };
};

const DuplicateProjectForm = {
  new: _new,
  toMutation,
};

export default DuplicateProjectForm;
